import { createContext, useContext, useState } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return null;
      const payload = JSON.parse(atob(token.split('.')[1]));
      // Accepter tout token admin valide (role=admin ou isAdmin=true)
      return (payload.role === 'admin' || payload.isAdmin) ? payload : null;
    } catch { return null; }
  });

  const login = async (username, pin) => {
    const { data } = await api.post('/admin/login', { username, pin });
    localStorage.setItem('token', data.token);
    // Décoder le token pour avoir toutes les infos (dont isAdmin)
    const payload = JSON.parse(atob(data.token.split('.')[1]));
    setUser(payload);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
